import { render } from "./billingDetail.vue?vue&type=template&id=1b449ecc&scoped=true&ts=true"
import script from "./billingDetail.vue?vue&type=script&lang=ts"
export * from "./billingDetail.vue?vue&type=script&lang=ts"

import "./billingDetail.vue?vue&type=style&index=0&id=1b449ecc&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b449ecc"]])

export default __exports__